import type { DateRange } from '@mui/x-date-pickers-pro';
import { isValid, startOfDay } from 'date-fns';

function toDate(value: unknown): Date | null {
  if (
    !(value instanceof Date) &&
    typeof value !== 'string' &&
    typeof value !== 'number'
  )
    return null;
  const date = new Date(value);
  return isValid(date) ? date : null;
}

/**
 * The v5 pickers parsed their own value; v6 takes only a Date or null. This
 * keeps v5's parse: undefined meant now, and an unparseable value meant empty.
 * `now` is passed in so the value stays equal across renders.
 */
export function toPickerDate(value: unknown, now: Date): Date | null {
  return value === undefined ? now : toDate(value);
}

/** v5's range parse: each end parses as a date, then moves to its start of day. */
export function toPickerRange(value: unknown, now: Date): DateRange<Date> {
  const [start, end]: unknown[] = Array.isArray(value) ? value : [null, null];
  const startDate = toPickerDate(start, now);
  const endDate = toPickerDate(end, now);
  return [startDate && startOfDay(startDate), endDate && startOfDay(endDate)];
}
